const SearchConst = {
    SelectedDealer: 'SelectedDealer',
};

const DealerAction = {
    searchrequest,
};


function searchrequest(payload) {
    console.log(payload,"dealer selected redux action")
    return { type: SearchConst.SelectedDealer, payload };
}


export default DealerAction;